// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Top Navbar Specific Styles */
.TopSubMenu_topMenuContainer__HHh1U {
  position: relative;
  overflow: visible;
  height: fit-content;
  flex: 0 0 auto; /* Don't grow or shrink */
}

.TopSubMenu_topSidebarLink__Mip8p {
  display: flex;
  color: var(--themeFontColor);
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  text-decoration: none;
  font-size: 13.5px;
  border-radius: 5px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.2s ease;
  background: transparent;
}

.TopSubMenu_topSidebarLink__Mip8p:hover {
  background: linear-gradient(225deg, var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);
  text-decoration: none;
  color: #fff !important;
}

.TopSubMenu_topSidebarLinkActive__r1N7P {
  background: linear-gradient(225deg, var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);
  color: #fff !important;
}

.TopSubMenu_lockedItem__-RHdn:hover {
  background: rgba(255, 107, 107, 0.1) !important;
  color: #ff6b6b !important;
}

.TopSubMenu_topLinkContent__KSiJz {
  display: flex;
  align-items: center;
  gap: 6px;
}

.TopSubMenu_topLinkIcon__IRaSJ {
  display: flex;
  align-items: center;
  justify-content: center;
}

.TopSubMenu_topLinkText__mDuvu {
  font-size: 13.5px;
}

.TopSubMenu_lockIcon__1o8wa {
  font-size: 16px !important;
  color: #ff6b6b;
  margin-left: 4px;
}

.TopSubMenu_viewBadge__JCgxC {
  font-size: 9px;
  padding: 2px 5px;
  background-color: #ffd700;
  border-radius: 3px;
  color: #000;
  font-weight: 600;
  margin-left: 4px;
  white-space: nowrap;
}

.TopSubMenu_dropdownIndicator__XxMVY {
  display: flex;
  align-items: center;
  color: var(--themeFontColor);
  margin-left: 4px;
}

.TopSubMenu_topDropdownMenu__xHvLW {
  box-shadow: var(--themeShadow);
  background: var(--themeColor);
  border-radius: 10px;
  margin: 0;
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 2000;
  width: max-content;
  min-width: 200px;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 0;
  animation: TopSubMenu_dropdownFadeIn__BXR3L 0.2s ease;
}

@keyframes TopSubMenu_dropdownFadeIn__BXR3L {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.TopSubMenu_topDropdownMenu__xHvLW::-webkit-scrollbar {
  width: 6px;
}

.TopSubMenu_topDropdownMenu__xHvLW::-webkit-scrollbar-track {
  background: transparent;
}

.TopSubMenu_topDropdownMenu__xHvLW::-webkit-scrollbar-thumb {
  background-color: rgba(155, 155, 155, 0.5);
  border-radius: 20px;
}

.TopSubMenu_topDropdownMenu__xHvLW::-webkit-scrollbar-thumb:hover {
  background-color: rgba(155, 155, 155, 0.7);
}

.TopSubMenu_topSidebarLink2__PzSK3 {
  display: flex;
  color: var(--themeFontColor);
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  width: 100%;
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  position: relative;
  transition: all 0.2s ease;
}

.TopSubMenu_topSidebarLink2__PzSK3:hover {
  background: linear-gradient(225deg, var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);
  color: #fff;
}

.TopSubMenu_topSidebarLink2Active__gWzgA {
  background: linear-gradient(225deg, var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);
  color: #fff !important;
}

.TopSubMenu_lockedSubItem__6vhSk:hover {
  background: rgba(255, 107, 107, 0.1) !important;
  color: #ff6b6b !important;
}

.TopSubMenu_subLinkContent__dx73H {
  display: flex;
  align-items: center;
  gap: 8px;
}

.TopSubMenu_subLinkIcon__REe1b {
  display: flex;
  align-items: center;
  justify-content: center;
}

.TopSubMenu_subLinkText__XIJYW {
  font-size: 13px;
}

.TopSubMenu_subLinkBadges__VeA54 {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
  padding-left: 12px;
}

.TopSubMenu_lockIconSub__LWJDH {
  font-size: 14px !important;
  color: #ff6b6b;
}

.TopSubMenu_viewBadgeSub__cgyzo {
  font-size: 8px;
  padding: 2px 4px;
  background-color: #ffd700;
  border-radius: 3px;
  color: #000;
  font-weight: 600;
  white-space: nowrap;
}

.TopSubMenu_inlinetext__FoSP\\+ {
  display: inline-block !important;
}

/* Responsive Styles - Multi-row wrapping */
@media screen and (max-width: 1400px) {
  .TopSubMenu_topSidebarLink__Mip8p {
    font-size: 12.5px;
    padding: 7px 10px;
  }

  .TopSubMenu_topLinkText__mDuvu {
    font-size: 12.5px;
  }
}

@media screen and (max-width: 1200px) {
  .TopSubMenu_topSidebarLink__Mip8p {
    font-size: 12px;
    padding: 6px 9px;
  }

  .TopSubMenu_topLinkText__mDuvu {
    font-size: 12px;
  }

  .TopSubMenu_topDropdownMenu__xHvLW {
    min-width: 180px;
  }

  .TopSubMenu_topSidebarLink2__PzSK3 {
    padding: 9px 16px;
    font-size: 12px;
  }
}

@media screen and (max-width: 1024px) {
  .TopSubMenu_topSidebarLink__Mip8p {
    font-size: 11.5px;
    padding: 6px 8px;
  }

  .TopSubMenu_topLinkText__mDuvu {
    font-size: 11.5px;
  }
}

@media screen and (max-width: 768px) {
  .TopSubMenu_topSidebarLink__Mip8p {
    font-size: 11px;
    padding: 5px 7px;
  }

  .TopSubMenu_topLinkText__mDuvu {
    font-size: 11px;
  }

  .TopSubMenu_lockIcon__1o8wa {
    font-size: 13px !important;
  }

  .TopSubMenu_viewBadge__JCgxC {
    display: none;
  }

  .TopSubMenu_topDropdownMenu__xHvLW {
    min-width: 160px;
    max-height: 300px;
  }

  .TopSubMenu_topSidebarLink2__PzSK3 {
    padding: 8px 14px;
    font-size: 11px;
  }

  .TopSubMenu_viewBadgeSub__cgyzo {
    display: none;
  }
}

@media screen and (max-width: 480px) {
  .TopSubMenu_topSidebarLink__Mip8p {
    font-size: 10px;
    padding: 4px 6px;
  }

  .TopSubMenu_topLinkIcon__IRaSJ img {
    width: 14px !important;
    height: 14px !important;
  }

  .TopSubMenu_topLinkText__mDuvu {
    font-size: 10px;
  }

  .TopSubMenu_lockIcon__1o8wa {
    font-size: 12px !important;
  }

  .TopSubMenu_topDropdownMenu__xHvLW {
    min-width: 140px;
    max-height: 250px;
    left: -10px;
  }

  .TopSubMenu_topSidebarLink2__PzSK3 {
    padding: 7px 12px;
    font-size: 10px;
  }

  .TopSubMenu_lockIconSub__LWJDH {
    font-size: 12px !important;
  }
}

/* Dark Mode Styles */
[class="dark"] .TopSubMenu_topSidebarLink__Mip8p,
[class="leftsidebardark"] .TopSubMenu_topSidebarLink__Mip8p {
  color: #f3f3f3;
}

[class="dark"] .TopSubMenu_topSidebarLink__Mip8p:hover,
[class="leftsidebardark"] .TopSubMenu_topSidebarLink__Mip8p:hover {
  color: var(--themeFontColor);
}

[class="dark"] .TopSubMenu_topSidebarLink2__PzSK3,
[class="leftsidebardark"] .TopSubMenu_topSidebarLink2__PzSK3 {
  color: var(--darkHeadingTextColor);
}

[class="dark"] .TopSubMenu_topSidebarLink2__PzSK3:hover,
[class="leftsidebardark"] .TopSubMenu_topSidebarLink2__PzSK3:hover {
  color: var(--themeFontColor);
}

[class="dark"] .TopSubMenu_lockedItem__-RHdn:hover,
[class="leftsidebardark"] .TopSubMenu_lockedItem__-RHdn:hover {
  background: rgba(255, 107, 107, 0.15) !important;
}

[class="dark"] .TopSubMenu_lockedSubItem__6vhSk:hover,
[class="leftsidebardark"] .TopSubMenu_lockedSubItem__6vhSk:hover {
  background: rgba(255, 107, 107, 0.15) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/TopSidebar/TopSubMenu.module.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc,EAAE,yBAAyB;AAC3C;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,2FAA2F;EAC3F,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,2FAA2F;EAC3F,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,qDAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2FAA2F;EAC3F,WAAW;AACb;;AAEA;EACE,2FAA2F;EAC3F,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,2CAA2C;AAC3C;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,qBAAqB;AACrB;;EAEE,cAAc;AAChB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,gDAAgD;AAClD","sourcesContent":["/* Top Navbar Specific Styles */\r\n.topMenuContainer {\r\n  position: relative;\r\n  overflow: visible;\r\n  height: fit-content;\r\n  flex: 0 0 auto; /* Don't grow or shrink */\r\n}\r\n\r\n.topSidebarLink {\r\n  display: flex;\r\n  color: var(--themeFontColor);\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 8px 12px;\r\n  text-decoration: none;\r\n  font-size: 13.5px;\r\n  border-radius: 5px;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n  transition: all 0.2s ease;\r\n  background: transparent;\r\n}\r\n\r\n.topSidebarLink:hover {\r\n  background: linear-gradient(225deg, var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);\r\n  text-decoration: none;\r\n  color: #fff !important;\r\n}\r\n\r\n.topSidebarLinkActive {\r\n  background: linear-gradient(225deg, var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);\r\n  color: #fff !important;\r\n}\r\n\r\n.lockedItem:hover {\r\n  background: rgba(255, 107, 107, 0.1) !important;\r\n  color: #ff6b6b !important;\r\n}\r\n\r\n.topLinkContent {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.topLinkIcon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.topLinkText {\r\n  font-size: 13.5px;\r\n}\r\n\r\n.lockIcon {\r\n  font-size: 16px !important;\r\n  color: #ff6b6b;\r\n  margin-left: 4px;\r\n}\r\n\r\n.viewBadge {\r\n  font-size: 9px;\r\n  padding: 2px 5px;\r\n  background-color: #ffd700;\r\n  border-radius: 3px;\r\n  color: #000;\r\n  font-weight: 600;\r\n  margin-left: 4px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.dropdownIndicator {\r\n  display: flex;\r\n  align-items: center;\r\n  color: var(--themeFontColor);\r\n  margin-left: 4px;\r\n}\r\n\r\n.topDropdownMenu {\r\n  box-shadow: var(--themeShadow);\r\n  background: var(--themeColor);\r\n  border-radius: 10px;\r\n  margin: 0;\r\n  position: absolute;\r\n  top: calc(100% + 8px);\r\n  left: 0;\r\n  z-index: 2000;\r\n  width: max-content;\r\n  min-width: 200px;\r\n  max-height: 400px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  padding: 8px 0;\r\n  animation: dropdownFadeIn 0.2s ease;\r\n}\r\n\r\n@keyframes dropdownFadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.topDropdownMenu::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.topDropdownMenu::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.topDropdownMenu::-webkit-scrollbar-thumb {\r\n  background-color: rgba(155, 155, 155, 0.5);\r\n  border-radius: 20px;\r\n}\r\n\r\n.topDropdownMenu::-webkit-scrollbar-thumb:hover {\r\n  background-color: rgba(155, 155, 155, 0.7);\r\n}\r\n\r\n.topSidebarLink2 {\r\n  display: flex;\r\n  color: var(--themeFontColor);\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px 20px;\r\n  width: 100%;\r\n  text-decoration: none;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  position: relative;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.topSidebarLink2:hover {\r\n  background: linear-gradient(225deg, var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);\r\n  color: #fff;\r\n}\r\n\r\n.topSidebarLink2Active {\r\n  background: linear-gradient(225deg, var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);\r\n  color: #fff !important;\r\n}\r\n\r\n.lockedSubItem:hover {\r\n  background: rgba(255, 107, 107, 0.1) !important;\r\n  color: #ff6b6b !important;\r\n}\r\n\r\n.subLinkContent {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.subLinkIcon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.subLinkText {\r\n  font-size: 13px;\r\n}\r\n\r\n.subLinkBadges {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  margin-left: auto;\r\n  padding-left: 12px;\r\n}\r\n\r\n.lockIconSub {\r\n  font-size: 14px !important;\r\n  color: #ff6b6b;\r\n}\r\n\r\n.viewBadgeSub {\r\n  font-size: 8px;\r\n  padding: 2px 4px;\r\n  background-color: #ffd700;\r\n  border-radius: 3px;\r\n  color: #000;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n.inlinetext {\r\n  display: inline-block !important;\r\n}\r\n\r\n/* Responsive Styles - Multi-row wrapping */\r\n@media screen and (max-width: 1400px) {\r\n  .topSidebarLink {\r\n    font-size: 12.5px;\r\n    padding: 7px 10px;\r\n  }\r\n\r\n  .topLinkText {\r\n    font-size: 12.5px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1200px) {\r\n  .topSidebarLink {\r\n    font-size: 12px;\r\n    padding: 6px 9px;\r\n  }\r\n\r\n  .topLinkText {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .topDropdownMenu {\r\n    min-width: 180px;\r\n  }\r\n\r\n  .topSidebarLink2 {\r\n    padding: 9px 16px;\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .topSidebarLink {\r\n    font-size: 11.5px;\r\n    padding: 6px 8px;\r\n  }\r\n\r\n  .topLinkText {\r\n    font-size: 11.5px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .topSidebarLink {\r\n    font-size: 11px;\r\n    padding: 5px 7px;\r\n  }\r\n\r\n  .topLinkText {\r\n    font-size: 11px;\r\n  }\r\n\r\n  .lockIcon {\r\n    font-size: 13px !important;\r\n  }\r\n\r\n  .viewBadge {\r\n    display: none;\r\n  }\r\n\r\n  .topDropdownMenu {\r\n    min-width: 160px;\r\n    max-height: 300px;\r\n  }\r\n\r\n  .topSidebarLink2 {\r\n    padding: 8px 14px;\r\n    font-size: 11px;\r\n  }\r\n\r\n  .viewBadgeSub {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  .topSidebarLink {\r\n    font-size: 10px;\r\n    padding: 4px 6px;\r\n  }\r\n\r\n  .topLinkIcon img {\r\n    width: 14px !important;\r\n    height: 14px !important;\r\n  }\r\n\r\n  .topLinkText {\r\n    font-size: 10px;\r\n  }\r\n\r\n  .lockIcon {\r\n    font-size: 12px !important;\r\n  }\r\n\r\n  .topDropdownMenu {\r\n    min-width: 140px;\r\n    max-height: 250px;\r\n    left: -10px;\r\n  }\r\n\r\n  .topSidebarLink2 {\r\n    padding: 7px 12px;\r\n    font-size: 10px;\r\n  }\r\n\r\n  .lockIconSub {\r\n    font-size: 12px !important;\r\n  }\r\n}\r\n\r\n/* Dark Mode Styles */\r\n[class=\"dark\"] .topSidebarLink,\r\n[class=\"leftsidebardark\"] .topSidebarLink {\r\n  color: #f3f3f3;\r\n}\r\n\r\n[class=\"dark\"] .topSidebarLink:hover,\r\n[class=\"leftsidebardark\"] .topSidebarLink:hover {\r\n  color: var(--themeFontColor);\r\n}\r\n\r\n[class=\"dark\"] .topSidebarLink2,\r\n[class=\"leftsidebardark\"] .topSidebarLink2 {\r\n  color: var(--darkHeadingTextColor);\r\n}\r\n\r\n[class=\"dark\"] .topSidebarLink2:hover,\r\n[class=\"leftsidebardark\"] .topSidebarLink2:hover {\r\n  color: var(--themeFontColor);\r\n}\r\n\r\n[class=\"dark\"] .lockedItem:hover,\r\n[class=\"leftsidebardark\"] .lockedItem:hover {\r\n  background: rgba(255, 107, 107, 0.15) !important;\r\n}\r\n\r\n[class=\"dark\"] .lockedSubItem:hover,\r\n[class=\"leftsidebardark\"] .lockedSubItem:hover {\r\n  background: rgba(255, 107, 107, 0.15) !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topMenuContainer": `TopSubMenu_topMenuContainer__HHh1U`,
	"topSidebarLink": `TopSubMenu_topSidebarLink__Mip8p`,
	"topSidebarLinkActive": `TopSubMenu_topSidebarLinkActive__r1N7P`,
	"lockedItem": `TopSubMenu_lockedItem__-RHdn`,
	"topLinkContent": `TopSubMenu_topLinkContent__KSiJz`,
	"topLinkIcon": `TopSubMenu_topLinkIcon__IRaSJ`,
	"topLinkText": `TopSubMenu_topLinkText__mDuvu`,
	"lockIcon": `TopSubMenu_lockIcon__1o8wa`,
	"viewBadge": `TopSubMenu_viewBadge__JCgxC`,
	"dropdownIndicator": `TopSubMenu_dropdownIndicator__XxMVY`,
	"topDropdownMenu": `TopSubMenu_topDropdownMenu__xHvLW`,
	"dropdownFadeIn": `TopSubMenu_dropdownFadeIn__BXR3L`,
	"topSidebarLink2": `TopSubMenu_topSidebarLink2__PzSK3`,
	"topSidebarLink2Active": `TopSubMenu_topSidebarLink2Active__gWzgA`,
	"lockedSubItem": `TopSubMenu_lockedSubItem__6vhSk`,
	"subLinkContent": `TopSubMenu_subLinkContent__dx73H`,
	"subLinkIcon": `TopSubMenu_subLinkIcon__REe1b`,
	"subLinkText": `TopSubMenu_subLinkText__XIJYW`,
	"subLinkBadges": `TopSubMenu_subLinkBadges__VeA54`,
	"lockIconSub": `TopSubMenu_lockIconSub__LWJDH`,
	"viewBadgeSub": `TopSubMenu_viewBadgeSub__cgyzo`,
	"inlinetext": `TopSubMenu_inlinetext__FoSP+`
};
export default ___CSS_LOADER_EXPORT___;
